// extracted by mini-css-extract-plugin
export default {"table":"GridTable_table__vRoC0","box":"GridTable_box__FGQC2","item":"GridTable_item__rWbNE","key":"GridTable_key__6ozKB","value":"GridTable_value__bIWMi"};